import { Component } from "@angular/core";
import { FunctionService } from "../../model-services/function.service";
import { SCREEN } from "../layouts-enums";
import { User } from "../../common/user";
import { UserService } from "../../user/user.service";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-users-layout',
    templateUrl: './users-layout.html',
    standalone: false
})
export class UsersLayoutComponent {    
    loading:boolean = false
    screen:SCREEN = SCREEN.USERS
    users:User[]
    routeSub:Subscription

    constructor(private functionService: FunctionService, private route:ActivatedRoute, private userService:UserService) {
    }

    ngOnDestroy(): void {
        if (this.routeSub) this.routeSub.unsubscribe()
    }

    ngOnInit() {
        setTimeout(() => {
            this.routeSub = this.route.params.subscribe(async p => {
                this.reloadUsers()
            })
        })
    }

    handleFunctionEvent(event) {       
        this.functionService.executeFunction(event.function, event.value)
    }

    async reloadUsers() {
        this.loading = true
        try {
            this.users = await this.userService.getUsersAsAdmin()
        }finally {
            this.loading = false
        }
    }

}